export const SMART_LOGIN_COOKIE = 'hs_login_email';
export const SMART_LOGIN_REDIRECT = '/';
export const SSO_LOGIN_POPUP_URL = 'SSO_LOGIN_POPUP_URL';
export const SSO_LOGIN_POPUP_NEXTPATH = 'SSO_LOGIN_POPUP_NEXTPATH';
export const SSO_LV_TWO_FACTOR = 'SSO_LV_TWO_FACTOR';
export const SSO_LV_CONFIRM_TO_LOGIN = 'SSO_LV_CONFIRM_TO_LOGIN';
export const DEFAULT_LOGIN_REQUIREMENTS = ['HUBSPOT', 'GOOGLE', 'SSO', 'APPLE', 'MICROSOFT', 'PASSKEY'];
export const DEFAULT_LOGIN_REQUIREMENTS_V4 = ['PASSKEY', 'GOOGLE', 'MICROSOFT', 'APPLE', 'HUBSPOT', 'SSO'];